import {createStore} from "vuex";

const store = createStore({
    state () {
        return {
            departamento: null,
            color: "",
            count: 0,
            language: "pt"
        }
    },
    mutations: {
        increment (state) {
            state.count++
        },
        setDepartamento(state,departamento){
            state.departamento = departamento;
        },
        setColor(state,color){
            state.color = color;
        },
        setLanguage(state,lang){
            state.language = lang
        }
    }
});

export default store;